import React, { useState, useEffect } from 'react'
import { Panel, Icon, Button } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../utils/loading'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import ContractCenterCommentForm from './ContractCenterCommentForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  getContractCenterReviewBeforeApprove,
  saveContractCenterReviewBeforeApprove,
  updateReadyForReviewBeforeApprove,
} from '../../redux/actions/proposeConsiderApproveProject'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG, SAVE_DRAFT_SUCCESS_MSG } from '../../constants/msgText'
import './styles.less'

export default function ContractCenterCommentBeforeApproveWidget(props) {
  const { showCommandButton, schema, onSuccess = () => {} } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isSaveDraftSuccess, setIsSaveDraftSuccess] = useState(false)
  const [isShowConfimSendContectCenter, setIsShowConfimSendContectCenter] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  const [formSchema, setFormSchema] = useState(schema)
  // const [formSchema, setFormSchema] = useState(mockSchema)
  const [editorData, setEditorData] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('schema', schema)

    schema && setFormSchema(schema)

    if (schema?.editorData?.value) {
      const output = schema?.editorData?.value?.replace(/<img\b([^>]*)>/g, (match, attrs) => {
        const trimmedAttrs = attrs.trim()

        // ตรวจสอบว่ามี width หรือ height อยู่แล้วหรือไม่
        if (
          /width\s*=\s*["']?\d+["']?/i.test(trimmedAttrs) ||
          /height\s*=\s*["']?\d+["']?/i.test(trimmedAttrs)
        ) {
          return match // ไม่แทรกซ้ำ
        }

        return `<img ${trimmedAttrs} width="460" height="345">`
      })

      // console.log('output -=> ', output)

      setEditorData(output)
    } else {
      setEditorData('')
    }

    // setEditorData(schema?.editorData?.value)
    setIsEdit(!schema?.disabled)
  }, [schema])

  const handleCallUpdateComment = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveContractCenterReviewBeforeApprove(projectId, request)
      if (response.success) {
        //setFormSchema(response)
        setIsShowConfimModal(false)

        // let _schema = await getContractCenterReviewBeforeApprove(projectId, request)
        // setFormSchema(_schema?.forms)

        if (isSaveDraft) {
          notification.open('success', {
            title: SAVE_DRAFT_SUCCESS_MSG,
            duration: 10000,
          })
        } else {
          onSuccess()
          notification.open('success', {
            title: SAVE_SUCCESS_MSG,
            duration: 10000,
          })
        }
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsShowConfimModal(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleCallSendContractCenter = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await updateReadyForReviewBeforeApprove(projectId)
      if (response.success) {
        //setFormSchema(response)
        setIsShowConfimSendContectCenter(false)
        onSuccess()
        notification.open('success', {
          title: 'แจ้งศูนย์สัญญาสำเร็จ',
          duration: 10000,
        })
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsShowConfimSendContectCenter(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleOnConfirmModal = (data) => {
    console.log('data', data)

    let request = {
      projectVersionId: projectId,
      comment: data.editorData,
      isApprrove: data.contratCenterApprove,
      isSaveDraft: isSaveDraft,
    }
    console.log('request', request)
    handleCallUpdateComment(request)
  }

  const onSubmitDraft = (data) => {
    console.log('onSubmitDraft : ', data)

    setIsSaveDraft(true)
    setIsShowConfimModal(true)
  }

  const onSubmit = (data) => {
    console.log('onSubmit : ', data)

    setIsSaveDraft(false)
    setIsShowConfimModal(true)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <ContractCenterCommentForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : editorData ? (
        <>
          <div
            style={{ wordWrap: 'break-word' }}
            className="image-responsive"
            dangerouslySetInnerHTML={{ __html: editorData }}
          />
          <br />
        </>
      ) : (
        '-ไม่ได้ระบุ-'
      )}

      {formSchema?.contratCenterApprove?.value ? (
        <>
          <Icon icon="check-circle" size="2x" style={{ color: '#2da888' }} />
          <span style={{ marginLeft: 5 }}>{formSchema.contratCenterApprove.label}</span>
        </>
      ) : (
        formSchema?.isCoordinator &&
        formSchema?.status == 0 && (
          <p>
            <Button
              // style={{ width: 160 }}
              // appearance="ghost"
              style={{ marginRight: 20 }}
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={() => setIsShowConfimSendContectCenter(true)}
              disabled={isLoading}
            >
              {'แจ้งศูนย์สัญญาตรวจสอบ'}
            </Button>
          </p>
        )
      )}

      {showCommandButton && (
        <>
          <hr />

          <Button
            // style={{ width: 160 }}
            // appearance="ghost"
            style={{ marginRight: 20 }}
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading}
          >
            {formSchema.buttonText}
          </Button>

          <SaveButton
            style={{ marginRight: 20 }}
            onClick={handleSubmit(onSubmitDraft)}
            disabled={isLoading}
          >
            บันทึกร่าง
          </SaveButton>
        </>
      )}

      <ConfirmWidget
        title={`ยืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText}`}
        show={isShowConfimModal}
        detail={`กรุณายืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText}`}
        onCancle={() => {
          //setIsSaveDraft(false)
          setIsShowConfimModal(false)
        }}
        onConfirm={handleSubmit(handleOnConfirmModal)}
      />

      <ConfirmWidget
        title={`ยืนยันการยืนยันการแจ้งศูนย์สัญญา`}
        show={isShowConfimSendContectCenter}
        detail={`กรุณายืนยันการยืนยันการแจ้งศูนย์สัญญา`}
        onCancle={() => {
          setIsShowConfimSendContectCenter(false)
        }}
        onConfirm={handleCallSendContractCenter}
      />
    </Panel>
  )
}
